import { Theme, css } from '@emotion/react';
import React from 'react';

const DEFAULT_VERTICAL_SPACING_UNITS = 6;
const DEFAULT_VERTICAL_SPACING_UNITS_DESKTOP = 9;

const outerContainer =
  ({
    verticalSpacingUnits,
    verticalSpacingUnitsDesktop,
    includeMaxWidth,
  }: {
    verticalSpacingUnits: number;
    verticalSpacingUnitsDesktop: number;
    includeMaxWidth: boolean;
  }) =>
  ({ breakpoints, spacing }: Theme) => css`
    padding: 0 ${spacing(includeMaxWidth ? 2.5 : 0)}px;
    margin-top: ${spacing(verticalSpacingUnits)}px;

    &:last-of-type {
      margin-bottom: ${spacing(6)}px;
    }

    ${breakpoints.up('md')} {
      padding: 0 ${spacing(includeMaxWidth ? 7.5 : 0)}px;
      margin-top: ${spacing(verticalSpacingUnitsDesktop)}px;

      &:last-of-type {
        margin-bottom: ${spacing(verticalSpacingUnitsDesktop)}px;
      }
    }
  `;

const innerContainer = ({ breakpoints }: Theme) => css`
  max-width: ${breakpoints.values.lgx}px;
  margin: auto;
`;

interface WidgetLayoutContainerProps extends React.ComponentPropsWithoutRef<'div'> {
  className?: string;
  verticalSpacingUnits?: number;
  verticalSpacingUnitsDesktop?: number;
  includeMaxWidth?: boolean;
}

const WidgetLayoutContainer = React.forwardRef<HTMLDivElement, WidgetLayoutContainerProps>(
  (
    {
      children,
      includeMaxWidth = true,
      verticalSpacingUnits = DEFAULT_VERTICAL_SPACING_UNITS,
      verticalSpacingUnitsDesktop = DEFAULT_VERTICAL_SPACING_UNITS_DESKTOP,
      ...props
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        {...props}
        css={outerContainer({ verticalSpacingUnits, verticalSpacingUnitsDesktop, includeMaxWidth })}
      >
        <div css={[includeMaxWidth && innerContainer]}>{children}</div>
      </div>
    );
  }
);

export default WidgetLayoutContainer;
